export const ROUTE_PRODUCT = '/produto/'
export const ROUTE_PRODUCT_EXP = '/experiencia/'
export const ROUTE_PRODUCT_INDEX = '/produtos/'

export default { product: ROUTE_PRODUCT, products: ROUTE_PRODUCT_INDEX }
